export const SCANNER_CARD_TITLES = {
    types: 'Тип',
    grounds: 'Основание для включения',
    inclusion: 'Дата включения',
    exclusion: 'Дата исключения',
};
export const SCANNER_CONTEXT = {
    auth: {
        title: 'Вход или регистрация',
        text: 'Чтобы получить доступ к сканеру иноагентов, причастных к экстремизму и терроризму и организаций, признанных нежелательными:',
        list: [
            'Войдите или зарегистрируйтесь на сайте Forbes.',
            'Заполните форму на предоставление доступа к сканеру.',
            'Ожидайте одобрения заявки.',
        ],
        button: {
            text: 'Войти',
        },
    },
    application: {
        title: 'Отправка заявки',
        text: 'Чтобы получить доступ к сканеру иноагентов, причастных к экстремизму и терроризму и организаций, признанных нежелательными:',
        list: [
            'Войдите или зарегистрируйтесь на сайте Forbes.',
            'Заполните форму на предоставление доступа к сканеру.',
            'Ожидайте одобрения заявки.',
        ],
        button: {
            text: 'Оставить заявку',
        },
    },
    waiting: {
        title: 'Ожидание рассмотрения заявки',
        text: 'Ваша заявка на доступ к сканеру иноагентов, причастных к экстремизму и терроризму и организаций, признанных нежелательными успешно отправлена и находится на рассмотрении. Пожалуйста, ожидайте уведомления о результате.',
        button: {
            text: 'Вернуться на главную',
            to: '/',
        },
    },
    recall: {
        title: 'Заявка отклонена',
        text: 'К сожалению, ваша заявка была отклонена. Вы можете отправить новую заявку.',
        button: {
            text: 'Оставить заявку',
        },
    },
    provide: null,
};
export const USER_REQUEST_TYPE = {
    0: 'waiting',
    1: 'provide',
    2: 'recall',
    3: 'recall',
};
